export default __webpack_public_path__ + "static/reykjavik-e34d901f11fa5d3bb34ed976f24eb81a.jpg";